import { packagingTypes } from '@/common/constants'

export const packagingTypeLabels = {
  [packagingTypes.box]: 'Caja',
  [packagingTypes.envelope]: 'Sobre',
  [packagingTypes.softPackaging]: 'Embalaje blando',
}
